var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Portal',{attrs:{"to":"mobile-footer-wrapper"}},[_vm._t("before"),_c('div',{staticClass:"mobile-footer"},[_vm._t("default")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }